import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/react"

export default () => (
  <StaticQuery
    query={graphql`
      query cliniquequery {
        file(relativePath: { eq: "clinique-du-sport.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        fluid={data.file.childImageSharp.fluid}
        alt="L'Espace Médical Vauban est situé à Paris 7ème arrondissement, en face du dôme des Invalides."
        css={css`
          width: 100%;
        `}
      />
    )}
  />
)
